import { columnNames } from "@/utils/table/columnNames";
import { equaldate } from "@/utils/rsql";

export const tableColumnsDefs = {
  selected: {
    headerName: columnNames.selected,
  },

  favorites: {
    headerName: columnNames.favorites,
  },

  hidden: {
    headerName: "",
    hide: true,
  },

  proposalNumber: {
    headerName: columnNames.proposalNumber,
    filterPath: "proposal.number",
    sortingPath: "proposal.number",
  },

  proposalSource: {
    headerName: columnNames.proposalSource,
    filterPath: "proposal.source.value",
  },

  proposalType: {
    headerName: columnNames.proposalType,
    filterPath: "proposal.procedureType.value",
  },

  status: {
    headerName: columnNames.status,
    filterPath: "status",
  },

  proposalName: {
    headerName: columnNames.proposalName,
    filterPath: "proposal.procedureName",
  },

  lotsNumber: {
    headerName: columnNames.lotsNumber,
    filterPath: "proposal.numberLots",
    sortingPath: "proposal.numberLots",
  },

  lot: {
    headerName: columnNames.lot,
    filterPath: "name",
  },

  quantity: {
    headerName: columnNames.quantity,
    filterPath: "quantity",
  },

  price: {
    headerName: columnNames.price,
    filterPath: "price",
    sortingPath: "price",
  },

  currency: {
    headerName: columnNames.currency,
    filterPath: "currency",
  },

  expirationDays: {
    headerName: columnNames.expirationDays,
    filterPath: "proposal.endDate",
    sortingPath: "proposal.endDate",
    operation: equaldate,
  },

  organization: {
    headerName: columnNames.organization,
    filterPath: "proposal.organization",
  },

  startDate: {
    headerName: columnNames.startDate,
    filterPath: "proposal.startDate",
    sortingPath: "proposal.startDate",
  },

  endDate: {
    headerName: columnNames.endDate,
    filterPath: "proposal.endDate",
    sortingPath: "proposal.endDate",
    operation: equaldate,
  },

  place: {
    headerName: columnNames.place,
    filterPath: "place",
  },

  deliveryTime: {
    headerName: columnNames.deliveryTime,
    filterPath: "deliveryTime",
  },

  contacts: {
    headerName: columnNames.contacts,
    filterPath: "proposal.contact",
  },

  unp: {
    headerName: columnNames.unp,
    filterPath: "proposal.UNP",
  },

  source: {
    headerName: columnNames.source,
    filterPath: "source",
  },

  paymentMethod: {
    headerName: columnNames.paymentMethod,
    filterPath: "paymentMethod",
  },

  paymentForBroker: {
    headerName: columnNames.paymentForBroker,
    filterPath: "proposal.paymentForBroker",
  },

  codeOKRB: {
    headerName: columnNames.codeOKRB,
    filterPath: "codeOKRB",
  },

  documents: {
    headerName: columnNames.documents,
    filterPath: "proposal.docs.name",
  },

  sector: {
    headerName: columnNames.sector,
    filterPath: "proposal.sector.value",
  },
};
